import { ICBLstatsBodyprops } from "@/api_framework/api_modals/CBL";
import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { useCBLListAPI } from "../PWL/useCBLListAPI";
import { useCBLStatsAPI } from "../PWL/useCBLStatsAPI";

const useReFetchCBL = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { CBLFilters } = routeState.state as IPatientWaitingListState;

  const fetchCBL = useCBLListAPI();
  const fetchCBLstats = useCBLStatsAPI();

  const constructedData: ICBLstatsBodyprops = {
    booking_date: CBLFilters?.booking_date,
    created_date: CBLFilters?.created_date,
    clinic_details: {
      id: CBLFilters?.clinic_details?.id,
    },
    service_details: {
      id: CBLFilters?.service_details?.id,
    },
    sub_service_details: {
      id: CBLFilters?.sub_service_details?.id,
    },
    created_by: {
      id: CBLFilters?.created_by?.id,
    },
  };
  const execute = async () => {
    if (Object.keys(CBLFilters ?? {})?.length > 0) {
      await fetchCBL(constructedData);
      await fetchCBLstats(constructedData);
    }
  };
  return execute;
};

export default useReFetchCBL;
